import moment from 'moment';
import { toCurrency, toDate } from './format.util';
import {
  SELLING_PLATFORM_OPTIONS,
  LISTING_TYPE_OPTIONS,
  VERIFIED_OPTIONS,
  CERTIFIED_OPTIONS,
  BEST_OFFER_STATUS_OPTIONS,
} from '../constants';

export function getFiltersUrlParams(filters, urlCreation = false) {
  const searchFilters = [];

  if (filters.minValue && filters.maxValue) {
    searchFilters.push(`currentValue:gte=${filters.minValue}=>lte=${filters.maxValue}`);
  } else if (filters.minValue) {
    searchFilters.push(`currentValue:gte=${filters.minValue}`);
  } else if (filters.maxValue) {
    searchFilters.push(`currentValue:lte=${filters.maxValue}`);
  }

  if (filters.minPrice && filters.maxPrice) {
    searchFilters.push(`price:gte=${filters.minPrice}=>lte=${filters.maxPrice}`);
  } else if (filters.minPrice) {
    searchFilters.push(`price:gte=${filters.minPrice}`);
  } else if (filters.maxPrice) {
    searchFilters.push(`price:lte=${filters.maxPrice}`);
  }

  if (filters.minMarketValue && filters.maxMarketValue) {
    searchFilters.push(`marketValue:gte=${filters.minMarketValue}=>lte=${filters.maxMarketValue}`);
  } else if (filters.minMarketValue) {
    searchFilters.push(`marketValue:gte=${filters.minMarketValue}`);
  } else if (filters.maxMarketValue) {
    searchFilters.push(`marketValue:lte=${filters.maxMarketValue}`);
  }

  if (filters.minCards && filters.maxCards) {
    searchFilters.push(`totalCards:gte=${filters.minCards}=>lte=${filters.maxCards}`);
  } else if (filters.minCards) {
    searchFilters.push(`totalCards:gte=${filters.minCards}`);
  } else if (filters.maxCards) {
    searchFilters.push(`totalCards:lte=${filters.maxCards}`);
  }

  if (filters.minYear && filters.maxYear) {
    searchFilters.push(`year:gte=${filters.minYear}=>lte=${filters.maxYear}`);
  } else if (filters.minYear) {
    searchFilters.push(`year:gte=${filters.minYear}`);
  } else if (filters.maxYear) {
    searchFilters.push(`year:lte=${filters.maxYear}`);
  }

  if (filters.minPop && filters.maxPop) {
    searchFilters.push(`pop:gte=${filters.minPop}=>lte=${filters.maxPop}`);
  } else if (filters.minPop) {
    searchFilters.push(`pop:gte=${filters.minPop}`);
  } else if (filters.maxPop) {
    searchFilters.push(`pop:lte=${filters.maxPop}`);
  }

  if (filters.minDate && filters.maxDate) {
    searchFilters.push(`date:gte=${moment(filters.minDate).format('yyyy-MM-DD')}=>lte=${moment(filters.maxDate).format('yyyy-MM-DD')}`);
  } else if (filters.minDate) {
    searchFilters.push(`date:gte=${moment(filters.minDate).format('yyyy-MM-DD')}`);
  } else if (filters.maxDate) {
    searchFilters.push(`date:lte=${moment(filters.maxDate).format('yyyy-MM-DD')}`);
  }

  if (filters.date) {
    searchFilters.push(`date:gte=${moment(filters.date).format('yyyy-MM-DD')}`);
  }

  if (filters.cardId) {
    searchFilters.push(`cardId:${filters.cardId}`);
  }

  if (filters.category) {
    searchFilters.push(`category:${filters.category}`);
  }

  if (filters.categories && filters.categories.length) {
    searchFilters.push(`category:${filters.categories.map((category) => typeof category === 'string' ? category : category.value).join(',')}`);
  }

  if (filters.platforms && filters.platforms.length) {
    searchFilters.push(`platform:${filters.platforms.map(({ value }) => value).join(',')}`);
  }

  if (filters.condition) {
    searchFilters.push(`condition:${filters.condition}`);
  }

  if (filters.conditions && filters.conditions.length) {
    searchFilters.push(`condition:${filters.conditions.map((condition) => typeof condition === 'string' ? condition : condition.value).join(',')}`);
  }

  if (filters.tags && filters.tags.length) {
    searchFilters.push(`tags:${filters.tags.map((condition) => condition).join(',')}`);
  }

  if (filters.player) {
    searchFilters.push(`player:${filters.player}`);
  }

  if (filters.playerIndexId) {
    searchFilters.push(`playerIndexId:${filters.playerIndexId}`);
  }

  if (filters.universalGemRateId) {
    searchFilters.push(`universalGemRateId:${filters.universalGemRateId}`);
  }

  if (filters.gemRateId) {
    searchFilters.push(`gemRateId:${filters.gemRateId}`);
  }

  if (filters.psaSpecId) {
    searchFilters.push(`psaSpecId:${filters.psaSpecId}`);
  }

  if (filters.gradingCompany) {
    searchFilters.push(`gradingCompany:${filters.gradingCompany}`);
  }

  if (filters.grader) {
    searchFilters.push(`grader:${filters.grader}`);
  }

  if (filters.graders && filters.graders.length) {
    searchFilters.push(`graderList:${filters.graders.map((g) => (typeof g === 'string' ? g : g.value)).join(',')}`);
  }

  if (filters.grade) {
    searchFilters.push(`grade:${filters.grade}`);
  }

  if (filters.profileId) {
    searchFilters.push(`profileId:${filters.profileId}`);
  }

  if (filters.autographGrade) {
    searchFilters.push(`autographGrade:${filters.autographGrade}`);
  }

  if (filters.qualifierType) {
    searchFilters.push(`qualifierType:${filters.qualifierType}`);
  }

  if (filters.hasQualifier === true) {
    searchFilters.push('hasQualifier:true');
  }

  if (filters.hasAutographGrade === true) {
    searchFilters.push('hasAutographGrade:true');
  }

  if (filters.employee && filters.employee !== 'all') {
    searchFilters.push(`employee:${filters.employee}`);
  }

  if (filters.type && filters.type !== 'all') {
    searchFilters.push(`type:${filters.type}`);
  }

  if (filters.status) {
    searchFilters.push(`status:${filters.status}`);
  }

  if (filters.seller && filters.seller.toLowerCase) {
    searchFilters.push(`seller:${filters.seller.toLowerCase()}`);
  }

  if (filters.listingType && filters.listingType !== 'all') {
    searchFilters.push(`listingType:${filters.listingType}`);
  }

  if (filters.hidden) {
    searchFilters.push(`hidden:${filters.hidden}`);
  }

  if (filters.hasProfileRedirect !== undefined) {
    searchFilters.push(`hasProfileRedirect:${filters.hasProfileRedirect}`);
  }

  if (filters.excludeFromMatches === true || filters.excludeFromMatches === false) {
    searchFilters.push(`excludeFromMatches:${filters.excludeFromMatches}`);
  }

  if (filters.hasMatches === true || filters.hasMatches === false) {
    searchFilters.push(`hasMatches:${filters.hasMatches}`);
  }

  if (filters.outlierIndex) {
    searchFilters.push(`outlierIndex:${filters.outlierIndex}`);
  }

  if (filters.endDate) {
    searchFilters.push(`endDate:gt=${filters.endDate}`);
  }

  if (filters.uid) {
    searchFilters.push(`uid:${filters.uid}`);
  }

  if (filters.public) {
    searchFilters.push(`public:${filters.public}`);
  }

  if (filters.image) {
    searchFilters.push(`image:${filters.image}`);
  }

  if (filters.hasQuantityAvailable) {
    searchFilters.push(`hasQuantityAvailable:${filters.hasQuantityAvailable}`);
  }

  if (filters.certified && filters.certified !== 'all') {
    searchFilters.push(`${filters.certified}:true`);
  }

  if (filters.bestOfferStatus && filters.bestOfferStatus !== 'all') {
    if (filters.bestOfferStatus === 'failed') {
      searchFilters.push('scrapeFailed:true');
    }

    if (filters.bestOfferStatus === 'success') {
      searchFilters.push('scrapeFailed:false');
    }
  }

  if (filters.collectionId) {
    searchFilters.push(`collectionId:${filters.collectionId}`);

    if (filters.sold === '') {
      searchFilters.push('hasQuantityAvailable:true');
    }

    if (filters.sold === 'sold') {
      searchFilters.push('sold:true');
    }
  }

  if (filters.likes) {
    searchFilters.push(`likes:${filters.likes}`);
  }

  if (filters.ids) {
    searchFilters.push(`ids:${filters.ids}`);
  }

  if (urlCreation) {
    if (filters.verified === 'verified') {
      searchFilters.push('exists:verified');
    }

    if (filters.verified === 'unverified') {
      searchFilters.push('notexists:unverified');
    }
  }

  return searchFilters.join('|');
}

export function getFiltersObject(filtersUrl) {
  const filters = {};

  if (!filtersUrl) {
    return filters;
  }

  const filtersArray = filtersUrl.split('|');

  filtersArray.forEach((filterParam) => {
    const [field, value] = filterParam.split(':');

    if (field === 'price') {
      const comparators = value.split('=>');

      comparators.forEach((comparator) => {
        const [comparatorField, comparatorValue] = comparator.split('=');

        filters[comparatorField === 'gte' ? 'minPrice' : 'maxPrice'] = Number(comparatorValue);
      });
    } else if (field === 'date') {
      const comparators = value.split('=>');

      comparators.forEach((comparator) => {
        const [comparatorField, comparatorValue] = comparator.split('=');

        filters[comparatorField === 'gte' ? 'minDate' : 'maxDate'] = moment(comparatorValue, 'yyyy-MM-DD').toDate();
      });
    } else if (field === 'platform') {
      filters.platforms = [];
      const platforms = value.split(',');

      platforms.forEach((platformValue) => {
        const platform = SELLING_PLATFORM_OPTIONS.find((platformOption) => platformOption.value === platformValue);

        if (platform) {
          filters.platforms.push(platform);
        }
      });
    } else if (field === 'exists') {
      filters.verified = 'verified';
    } else if (field === 'notexists') {
      filters.verified = 'unverified';
    } else if (field === 'hasQualifier' || field === 'hasAutographGrade') {
      filters[field] = value === 'true';
    } else {
      filters[field] = value;
    }
  });

  return filters;
}

export function getFilterDescription(filters, translationMap, population = null) {
  if (!filters) {
    return '';
  }

  const descriptionArray = [];

  if (filters.sold === 'sold') {
    descriptionArray.push('Sold Only');
  }

  if (filters.sold === 'all') {
    descriptionArray.push('Collection & Sold');
  }

  if (filters.category) {
    descriptionArray.push(filters.category);
  }

  if (filters.categories && filters.categories.length) {
    if (filters.categories.length === 1) descriptionArray.push(typeof filters.categories[0] === 'string' ? filters.categories[0] : filters.categories[0].value);
    else descriptionArray.push(`(${filters.categories.map((category) => typeof category === 'string' ? category : category.value).join(', ')})`);
  }

  if (filters.platforms && filters.platforms.length) {
    if (filters.platforms.length === 1) descriptionArray.push(filters.platforms[0].label);
    else descriptionArray.push(`(${filters.platforms.map(({ label }) => label).join(', ')})`);
  }

  if (filters.listingType && filters.listingType !== 'all') {
    descriptionArray.push(LISTING_TYPE_OPTIONS.find(({ value }) => value === filters.listingType).label);
  }

  if (filters.hasMatches === true || filters.hasMatches === false) {
    descriptionArray.push(filters.hasMatches ? 'Has matches' : 'No matches');
  }

  if (filters.verified && filters.verified !== 'all') {
    descriptionArray.push(VERIFIED_OPTIONS.find(({ value }) => value === filters.verified).label);
  }

  if (filters.conditions && filters.conditions.length) {
    if (filters.conditions.length === 1) descriptionArray.push(typeof filters.conditions[0] === 'string' ? filters.conditions[0] : filters.conditions[0].value);
    else descriptionArray.push(`(${filters.conditions.map((condition) => typeof condition === 'string' ? condition : condition.value).join(', ')})`);
  }

  if (filters.tags && filters.tags.length) {
    if (filters.tags.length === 1) descriptionArray.push(filters.tags[0]);
    else descriptionArray.push(`(${filters.tags.map((tag) => tag).join(', ')})`);
  }

  if (filters.minValue && filters.maxValue) {
    descriptionArray.push(`Between ${toCurrency(filters.minValue)} and ${toCurrency(filters.maxValue)}`);
  } else if (filters.minValue) {
    descriptionArray.push(`More than ${toCurrency(filters.minValue)}`);
  } else if (filters.maxValue) {
    descriptionArray.push(`Less than ${toCurrency(filters.maxValue)}`);
  }

  if (filters.minPrice && filters.maxPrice) {
    descriptionArray.push(`Between ${toCurrency(filters.minPrice)} and ${toCurrency(filters.maxPrice)}`);
  } else if (filters.minPrice) {
    descriptionArray.push(`More than ${toCurrency(filters.minPrice)}`);
  } else if (filters.maxPrice) {
    descriptionArray.push(`Less than ${toCurrency(filters.maxPrice)}`);
  }

  if (filters.minYear && filters.maxYear) {
    descriptionArray.push(`Between ${filters.minYear} and ${filters.maxYear}`);
  } else if (filters.minYear) {
    descriptionArray.push(`After ${filters.minYear}`);
  } else if (filters.maxYear) {
    descriptionArray.push(`Before ${filters.maxYear}`);
  }

  if (filters.minPop && filters.maxPop) {
    descriptionArray.push(`Pop between ${filters.minPop} and ${filters.maxPop}`);
  } else if (filters.minPop) {
    descriptionArray.push(`Pop greater than ${filters.minPop}`);
  } else if (filters.maxPop) {
    descriptionArray.push(`Pop less than ${filters.maxPop}`);
  }

  if (filters.minCards && filters.maxCards) {
    descriptionArray.push(`cards between ${filters.minCards} and ${filters.maxCards}`);
  } else if (filters.minCards) {
    descriptionArray.push(`# cards greater than ${filters.minCards}`);
  } else if (filters.maxCards) {
    descriptionArray.push(`# cards less than ${filters.maxCards}`);
  }

  if (filters.minDate && filters.maxDate) {
    descriptionArray.push(`Between ${toDate(filters.minDate)} and ${toDate(filters.maxDate)}`);
  } else if (filters.minDate) {
    descriptionArray.push(`After ${toDate(filters.minDate)}`);
  } else if (filters.maxDate) {
    descriptionArray.push(`Before ${toDate(filters.maxDate)}`);
  }

  if (filters.player) {
    descriptionArray.push(filters.player);
  }

  if (filters.seller) {
    descriptionArray.push(`Seller ID: ${filters.seller}`);
  }

  if (filters.universalGemRateId) {
    descriptionArray.push(filters.universalGemRateId);
  }

  if (filters.gemRateId) {
    descriptionArray.push(filters.gemRateId);
  }

  if (filters.gradingCompany) {
    descriptionArray.push(`Grader: ${filters.gradingCompany.toUpperCase()}`);
  }

  if (filters.graders && filters.graders.length) {
      descriptionArray.push(`Graders: (${filters.graders.map(({ value }) => value.toUpperCase()).join(', ')})`);
  }

  if (filters.grade) {
    descriptionArray.push(`Grade: ${filters.grade.replace('g', '').replace('_', '.').replace('auth', 'Auth')}`);
  }

  if (filters.grader) {
    descriptionArray.push(`Grader: ${filters.grader.toUpperCase()}`);
  }

  if (filters.autographGrade) {
    descriptionArray.push(`Autograph Grade: ${filters.autographGrade.replace('g', '').replace('_', '.').replace('auth', 'Auth')}`);
  }

  if (filters.profileId) {
    descriptionArray.push(`Profile: ${filters.profileId}`);
  }

  if (filters.qualifierType) {
    descriptionArray.push(`Qualifier: ${filters.qualifierType}`);
  }

  if (filters.hasQualifier === true) {
    descriptionArray.push('Has Qualifier');
  }

  if (filters.hasAutographGrade === true) {
    descriptionArray.push('Has Autograph');
  }

  if (filters.condition) {
    descriptionArray.push(`Condition: ${filters.condition.replace('g', '').replace('_', '.')}${filters.condition.includes('q') ? ' (Qualifier)' : ''}`);
  }

  if (filters.certified && filters.certified !== 'all') {
    descriptionArray.push(CERTIFIED_OPTIONS.find(({ value }) => value === filters.certified).label);
  }

  if (filters.bestOfferStatus && filters.bestOfferStatus !== 'all') {
    descriptionArray.push(BEST_OFFER_STATUS_OPTIONS.find(({ value }) => value === filters.bestOfferStatus).label);
  }

  let descriptionOutput = descriptionArray.join(', ');

  if (translationMap) {
    Object.keys(translationMap).forEach((key) => {
      descriptionOutput = descriptionOutput.replace(key, translationMap[key]);
    });
  }

  if (population) {
    descriptionOutput += ` (Pop ${population})`;
  }

  return descriptionOutput;
}

export function getMultiplierCardsProfileDisplay(card) {
  if (!card.multipliers || card.multipliers.length === 0) {
    return [];
  }

  const cards = [];

  card.multipliers.forEach((multiplierCard) => {
    const existingCardIndex = cards.findIndex((existingCard) => multiplierCard.card === existingCard.card);

    if (existingCardIndex > -1) {
      cards[existingCardIndex].value = ((cards[existingCardIndex].value * cards[existingCardIndex].count) + multiplierCard.value) / (cards[existingCardIndex].count + 1);
      cards[existingCardIndex].count += 1;
    } else {
      cards.push({ ...multiplierCard, count: 1 });
    }
  });

  return cards;
}
